
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { VinLookup } from "@/components/vin/VinLookup";
import { VinLookupHistory } from "@/components/vin/VinLookupHistory";
import { useVinLookup } from "@/hooks/useVinLookup";

const Calibration = () => {
  const { lookupHistory, deleteLookup } = useVinLookup();

  // Add type assertion to make the compiler happy
  const lookupHistoryWithRequired = lookupHistory.map(history => ({
    ...history,
    raw_dataone_response: history.raw_dataone_response || null
  }));

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Vehicle Lookup</CardTitle>
        </CardHeader>
        <CardContent>
          <VinLookup />
        </CardContent>
      </Card>
      
      <VinLookupHistory lookups={lookupHistoryWithRequired} onDelete={deleteLookup} />
    </div>
  );
};

export default Calibration;
